export var MULTI_SORT_HEADER_TITLE = __('Sort by');
export var FIELD_NAMES = {
  SORT_PREFERENCES: 'SORT_PREFERENCES'
};
export var OVERRIDE_MODAL_ZINDEX = 9999;
export var FIELD_IDS = {
  SORT_FIELD: 'sortField',
  SORT_ORDER: 'sortOrder'
};
export var TABLE_MANAGER_PROPS = {
  showHeader: false,
  showSubHeader: false
};